/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One clip of the promoted title, by a roster member. Named schema rather than an inline object — an inline one generates an InlineResponse type that breaks the client build.
 * @export
 * @interface RosterHighlight
 */
export interface RosterHighlight {
    /**
     * 
     * @type {string}
     * @memberof RosterHighlight
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RosterHighlight
     */
    title: string;
    /**
     * Playable embed URL. What the theater mounts.
     * @type {string}
     * @memberof RosterHighlight
     */
    embedUrl: string;
    /**
     * The clip's own page, for opening off-platform.
     * @type {string}
     * @memberof RosterHighlight
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof RosterHighlight
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {number}
     * @memberof RosterHighlight
     */
    durationSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof RosterHighlight
     */
    viewCount: number;
    /**
     * Whose clip it is — the roster member's display name.
     * @type {string}
     * @memberof RosterHighlight
     */
    creatorLabel: string;
    /**
     * Their Drop, when one is linked, so the card can route to them.
     * @type {string}
     * @memberof RosterHighlight
     */
    creatorDropSlug?: string;
}

/**
 * Check if a given object implements the RosterHighlight interface.
 */
export function instanceOfRosterHighlight(value: object): value is RosterHighlight {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('embedUrl' in value) || value['embedUrl'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('durationSeconds' in value) || value['durationSeconds'] === undefined) return false;
    if (!('viewCount' in value) || value['viewCount'] === undefined) return false;
    if (!('creatorLabel' in value) || value['creatorLabel'] === undefined) return false;
    return true;
}

export function RosterHighlightFromJSON(json: any): RosterHighlight {
    return RosterHighlightFromJSONTyped(json, false);
}

export function RosterHighlightFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosterHighlight {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'embedUrl': json['embedUrl'],
        'url': json['url'],
        'thumbnailUrl': json['thumbnailUrl'],
        'durationSeconds': json['durationSeconds'],
        'viewCount': json['viewCount'],
        'creatorLabel': json['creatorLabel'],
        'creatorDropSlug': json['creatorDropSlug'] == null ? undefined : json['creatorDropSlug'],
    };
}

export function RosterHighlightToJSON(json: any): RosterHighlight {
    return RosterHighlightToJSONTyped(json, false);
}

export function RosterHighlightToJSONTyped(value?: RosterHighlight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'embedUrl': value['embedUrl'],
        'url': value['url'],
        'thumbnailUrl': value['thumbnailUrl'],
        'durationSeconds': value['durationSeconds'],
        'viewCount': value['viewCount'],
        'creatorLabel': value['creatorLabel'],
        'creatorDropSlug': value['creatorDropSlug'],
    };
}

